import { Controller } from "@hotwired/stimulus"
import Chartkick from "chartkick"
import "chartkick/chart.js"

// Connects to data-controller="chart"
export default class extends Controller {
    static values = {
        type: String,
        data: Object,
        options: Object
    }

    connect() {
        this.renderChart()
    }

    renderChart() {
        const type = this.typeValue || "LineChart"
        const data = this.dataValue
        const options = this.optionsValue || {}

        // Support for common Chartkick types
        // Using simple naming convention mapping if needed, or direct access
        // Types: LineChart, PieChart, ColumnChart, BarChart, AreaChart, ScatterChart, GeoChart, Timeline

        if (Chartkick[type]) {
            new Chartkick[type](this.element, data, options)
        } else {
            console.error(`Chartkick type '${type}' is not supported or invalid.`)
        }
    }
}
